import { calculateTotal, formatMoney } from "../utils/invoiceMath";

export default function TotalsBar({ items, currencySymbol }) {
  const total = calculateTotal(items);

  return (
    <div className="total-row">
      <div className="total-bar">
        TOTAL AMOUNT: {currencySymbol} {formatMoney(total)}
      </div>
    </div>
  );
}
